import React, { useEffect, useRef, useState } from "react";

export default function InViewportRenderer(props) {
  const [isVisible, setIsVisible] = useState(false);
  const componentRef = useRef();

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0, // Adjust as needed; 0.5 means at least 50% of the component must be in the viewport
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        setIsVisible(entry.isIntersecting);
      });
    }, options);

    observer.observe(componentRef.current);

    // Clean up the observer when the component is unmounted
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={componentRef} {...props}>
      {isVisible && props.children}
    </div>
  );
}
